import React from 'react';
import * as PropTypes from 'prop-types'


const Logo = ({logo:{name, link}}) => {
  return <React.Fragment>
    <a className={`${name} logo`} href={link} rel={'nofollow'} target={'_blank'}/>
  </React.Fragment>
};


Logo.propTypes= {
  logo:PropTypes.object
};

export default Logo;